import classNames from 'classnames';
import { FC, FocusEvent, useCallback, useEffect, useState } from 'react';
import { useIntl } from 'react-intl';

import type { ColumnProps } from './model';

interface PercentColumnProps extends ColumnProps<string> {
  className?: string;
}

export const GridPercentColumn: FC<PercentColumnProps> = ({ value, className, id, setCellValue, placeholderKey }) => {
  const [internalValue, setInternalValue] = useState<Nullable<string>>(value);

  const onBlur = useCallback(
    (event: FocusEvent<HTMLInputElement>) => {
      if (value?.toString() !== event.currentTarget.value) {
        setCellValue(id, event.currentTarget.value);
      }
    },
    [id, setCellValue, value],
  );

  const onInternalChange = useCallback((e: FocusEvent<HTMLInputElement>) => {
    setInternalValue(e.target.value || null);
  }, []);

  useEffect(() => {
    setInternalValue(value);
  }, [value]);

  const { formatMessage } = useIntl();
  return (
    <div className={classNames('percent-with-unit-component input-group', className)}>
      <input
        placeholder={placeholderKey !== undefined ? formatMessage({ id: placeholderKey }) : undefined}
        className="form-control input-group-text"
        type="text"
        onBlur={onBlur}
        onChange={onInternalChange}
        value={internalValue || ''}
      ></input>
      <span className="unit input-group-text" data-e2e="unit">
        %
      </span>
    </div>
  );
};

GridPercentColumn.displayName = 'GridTextColumn';
